import React, { useState, useEffect } from "react";
 
const list = [
  {
    id: 'a',
    firstname: 'Robin',
    lastname: 'Wieruch',
    year: 1988,
  },
  {
    id: 'b',
    firstname: 'Dave',
    lastname: 'Davidds',
    year: 1990,
  },
  {
    id: 'c',
    firstname: 'Dave',
    lastname: 'Davidds',
    year: 1991,
  },
  {
    id: 'd',
    firstname: 'Dave',
    lastname: 'Davidds',
    year: 1991,
  },
];

const postsPerPage = 3;
let arrayForHoldingPosts = [];

const List = () => {
const [postsToShow, setPostsToShow] = useState([]);
  const [next, setNext] = useState(3);

  const loopWithSlice = (start, end) => {
    const slicedPosts = list.slice(start, end);
    arrayForHoldingPosts = [...arrayForHoldingPosts, ...slicedPosts];
    setPostsToShow(arrayForHoldingPosts);
  };

  useEffect(() => {
    loopWithSlice(0, postsPerPage);
  }, []);

  const handleShowMorePosts = () => {
    loopWithSlice(next, next + postsPerPage);
    setNext(next + postsPerPage);
  };

  return (
    <div>
      <ul>
        {postsToShow.map(item => (
          <li key={item.id}>

             {item.id} 

          </li>
        ))}
      </ul>
      <button onClick={handleShowMorePosts}>Load more</button>
    </div>
  );
}
 
export default List;